/* eslint-disable react-hooks/exhaustive-deps */
//LinksFeedPrimitive

import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { ALIGN, ILandingSection, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import Dummy from "./Dummy"
import { LinksFeedPrimitive } from "../primitive"


/* Protopia Ecosystem component */
export interface ILinksFeedProps {
   section: ILandingSection
   data: LinksFeedContent 
   i: number
}
const LinksFeed= (props: ILinksFeedProps): JSX.Element => {
    const data = props.data
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-links-feed-${props.section.id}`,
            `.landing-links-feed-${props.section.id} {
                display: flex;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom}; 
                z-index:1;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-links-feed-${props.section.id}`)
        }
    }, []) 

    return !!data.items  || true
        ?
        <div 
            className={`landing-content-container landing-links-feed landing-links-feed-${props.section.id} ${ data.className || "" } `} 
            style={ data.style || {} }  
            data-type={data.type} 
            data-content-id={data.id}
        >
            <LinksFeedPrimitive 
                primitive={ {
                    ...data, 
                    width:  width,
                    height: height || 70,
                    i: props.i
                } as any }
                section={ props.section }
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {...data, className: `landing-links-feed-${props.section.id}`}, 
            ...props 
        }} /> 
}
export default LinksFeed